module.exports = __webpack_public_path__ + "img/photo-7-1.5732c621.jpg";